import React, { useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaBell, FaSchool, FaHome, FaUserCheck, FaArrowLeft } from "react-icons/fa";
import { all_routes } from "../feature-module/router/all_routes";
import { ProductContext } from "../context/AppContext";

const CommonFooterNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const routes = all_routes;
  const currentPath = location.pathname;

  const { GetstudentData, Dashboarddata } = useContext(ProductContext) || {};
  const isAdmitted = GetstudentData?.is_admitted === true || Dashboarddata?.data?.isAdmission === true;

  if (!isAdmitted) {
    return null;
  }


  return (
    <div className="footer-nav">
      <div className={`nav-item ${currentPath === routes.SchoolNotice || currentPath === "/SchoolNotice" ? "active" : ""}`}>
        <Link to={routes.SchoolNotice || "/SchoolNotice"}>
          <FaBell />
          {/* <span>Updates</span> */}
          <span>Notice</span>
        </Link>
      </div>

      <div className={`nav-item ${currentPath === routes.schoolinfo || currentPath === "/school-info" || currentPath === routes.schoolrule || currentPath === "/schoolrule" ? "active" : ""}`}>
        <Link to={routes.schoolinfo || "/school-info"}>
          <FaSchool />
          <span>School Info</span>
        </Link>
      </div>


      <div className={`nav-item ${currentPath === "/" || currentPath === routes.index || currentPath === "/index" ? "active" : ""}`}>
        <Link to={routes.index || "/"} replace>
          <div className="center-btn">
            <FaHome />
          </div>
          <span>Home</span>
        </Link>
      </div>

      <div className={`nav-item ${currentPath === routes.studentprofileview || currentPath === "/studentprofileview" ? "active" : ""}`}>
        <Link to={routes.studentprofileview || "/studentprofileview"}>
          <FaUserCheck />
          <span>Profile</span>
        </Link>
      </div>

      <div className="nav-item" style={(currentPath === "/" || currentPath === routes.index || currentPath === "/index") ? { opacity: 0.5, pointerEvents: "none" } : {}}>
        <a href="#back" onClick={(e) => { 
          e.preventDefault(); 
          if (currentPath !== "/" && currentPath !== routes.index && currentPath !== "/index") {
            navigate(-1); 
          }
        }}>
          <FaArrowLeft />
          <span>Back</span>
        </a>
      </div>

    </div>
  );
};

export default CommonFooterNav;
